import Axios from "../../../_helpers/axiosHelper";
import { ITeamMember } from "../reducers";

export const getTeam = (teamId: string) => {
  return Axios.get(`/team/${teamId}`);
};
export const createTeamMember = (request: ITeamMember) => {
  const body: any = request;
  return Axios.post(`/team/${request.teamId}/member`, body);
};

export const updateTeamMember = (request: ITeamMember) => {
  const body: any = request;
  return Axios.put(`/team/${request.teamId}/member/${request.id}`, body);
};
export const deleteTeamMember = (request: ITeamMember) => {
  return Axios.delete(`/team/${request.teamId}/member/${request.id}`);
};
